import { CountryType, UsStateType } from 'data/App/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getAll = () =>
  fetchApi<Array<CountryType>>({
    method: 'GET',
    queryParams: { scope: 'mercury' },
    url: getApiUrl('nabu-gateway/countries')
  })

export const getUsStates = () =>
  fetchApi<Array<UsStateType>>({
    method: 'GET',
    url: getApiUrl('nabu-gateway/countries/US/states')
  })
